export {
  HeaderNavigationMenu as HeaderNavigationMenu,
  HeaderNavigationTabs as HeaderNavigationTabs,
} from './HeaderNavigation';
